export default __webpack_public_path__ + "static/media/token-utility.3ec3a82b.png";